export default "__VITE_ASSET__CcG5yGSU__"